module.exports = __webpack_public_path__ + "img/sensor-housing.cf9d255d.png";